<template>
  <section class="account-order-automated-emails">
    <div class="toggle-automated">
      <label for="automated_emails_enabled">
        <input data-cy="toggle_automation" id="automated_emails_enabled" @change="toggleAutomation" v-model="enabled" name="automated_emails_enabled" type="checkbox" />
        <span>Enable Automated Emails</span>
      </label>
    </div>
    <div v-if="enabled" data-cy="automations">
      <header data-cy="automation_header" class="automation-header">
        <div>Target Languages</div>
        <div>Types</div>
        <div>Emails</div>
      </header>
      <div data-cy="automation_row" v-for="(row, index) in rows" :key="index" class="row">
        <v-select 
          data-cy="target_language"
          class="target-language-select"
          :options="languages"
          placeholder="Select Language"
          v-model="row.targetLanguage"
          @input="onUpdate"
          label="targetlanguage"></v-select>

        <!-- <multiselect
          v-model="row.emails"
          :options="emailOptions"
          multiple
          label="email"
          track-by="email"
          placeholder="Add emails..."
          :taggable="true"
        ></multiselect> -->

        <v-select 
          data-cy="order_types"
          class="target-language-select"
          :options="availableTypes(row.targetLanguage, row.type)"
          placeholder="Select Type"
          @input="onUpdate"
          v-model="row.type"
          label="type">
            
          <span slot="no-options" @click="$refs.select.open = false">
            All availble types for this target language have been selected
          </span>
          </v-select>


        <multiselect
          data-cy="email_prefs"
          id="email_prefs_emails"
          placeholder="Type Email and press enter to select"
          v-model="row.emails"
          tag-placeholder="Press enter to add email"
          autocomplete="off"
          name="prefs"
          class="co-custom-arrow target-language-emails"
          :options="emailOptions"
          :multiple="true"
          :taggable="true"
          @remove="(email) => onRemoveEmail(email, row)"
          @tag="(email) => onEmail(email, row)">
          <span slot="noResult">No results found</span>
          <template slot="caret" slot-scope="{toggle}" :toggle="toggle">
            <chevron-down-icon :size="24" @mousedown.prevent.stop="toggle()" class="multiselect__select" />
          </template>
        </multiselect>

        <button class="delete-btn" @click="deleteRow(index, row)">x</button>
      </div>

      <button class="add-more-langs-btn" @click="addRow">Add more languages</button>
    </div>
  </section>
</template>

<script>
import {EmailIcon, ChevronDownIcon} from '../icons';
import axios from "axios";
import { mapGetters, mapActions, mapMutations } from 'vuex';
import './OrderAutomatedEmails.scss';
import isEmail from 'is-email';

export default {
  props: {

    accountId: {
      type: Number,
      required: true
    },
  },

  components: {
    ChevronDownIcon
  },
  data() {
    return {
      isDataFetched: {
        orderDetails: false,
        langauges: false,
      },
      enabled: true,
      languages: ['English (US)'],
      types: ['Advertising'],
      typesObjs: {},

      rows: [
        {
          targetLanguage: 'English (US)',
          type: 'Advertising',
          emails: [],
        },
      ],

      emailOptions: [],
    };
  },

  created () {

    //get and set the default language types
    this.getAccountOrderTypes(this.accountId).then((result) => {
      console.log('the order types result', result)
      this.typesObjs = result.types;
      this.types = result.types.map(type => type.name.trim());

      console.log('the types', this.types)

      this.isDataFetched.orderDetails = true;

      //get email automations for this account
      this.getAutomations().then(result => {
        if (!result.data.length) return;

        this.rows = result.data.map(row => {
          let {emails, language, type, id} = row;

          return { 
            targetLanguage: language,
            type,
            emails,
            id,
          }
        }).filter(row => {

          console.log('the type', row.type)

          //don't show types that don't exist
          return (this.types.includes(row.type.trim()));
        })

        console.log('the rows', this.rows)
      })
    });

    //get status of automations enabled 
    this.getAutomatedEmailsEnabled(this.accountId).then(result => {
      console.log('emails enabled?', result)
      this.enabled = result.data.isEnabled;
    })

    //get a list of source languages
    //@todo - currently using this as our list of target 
    //languages (does this include all available languages?)
    this.getSourceLanguages().then(result => {
      this.setSourceLanguages(result);

      //set the available lanugages
      this.$nextTick(() => {
        this.languages = this.sourceLanguages.map(language => {
          return language.description;
        })

        this.isDataFetched.languages = true;
      })
    })
  },

  computed: {

    ...mapGetters('CreateOrderStore', [
      'accountLanguageSets',
      'sourceLanguages',
    ]),

    /**
     * Get a unique list of all selected Order types
     * 
     * @return Array ['Advertising', 'Apps', ...]
     */
    // selectedTypes () {
    //   return [ ...new Set(this.rows.map(row => row.type)) ]
    // },

    /**
     * Get a unique list of all selected target langauges
     * 
     * @todo - may not need this
     * 
     * @return Array ['English (US)', ...]
     */
    selectedTargetLanguages () {
      return [ ...new Set(this.rows.map(row => row.targetLanguage)) ];
    },

    /**
     * Build an object keyed by lanugage name and fill
     * with an array of all currently selected types for
     * that language
     *  
     * @note - we need to know what types we've selected
     * for a particular language, so that we can exclude already selected types
     * from future dropdowns
     * 
     * @return Object { 'English (US)': ['Advertising', 'Apps', ...] }
     */
    selectedTypes () {
      let obj = {};

      this.languages.forEach(language => {
        obj[language] = [];
      })

      this.rows.forEach(row => {
        let {targetLanguage, type} = row;
        
        obj[targetLanguage] = obj[targetLanguage].concat(type)
      })

      return obj;
    }
  },

  methods: {

    ...mapActions('CreateOrderStore', [
      'getSourceLanguages',
      'getAccountOrderTypes',
      'setAutomatedEmailsEnabled',
      'getAutomatedEmailsEnabled'
    ]),

    ...mapMutations('CreateOrderStore', [
      'setSourceLanguages',
    ]),

    /**
     * set if email automations are enabled
     * 
     */
    toggleAutomation() {

      const accountId = this.accountId;

      this.setAutomatedEmailsEnabled({accountId, isEnabled: this.enabled})
        .then(result => {
          //console.log('automation enabled result', result)
        })
    },

    /**
     * on removal of an email
     * 
     * @param string email
     * @param Object row
     * 
     * @return void
     */
    onRemoveEmail (email, row) {
      this.$nextTick(() => {
        if (!row.emails.length) {
          //delete row on backend if it's now empty, so we 
          //don't have empty automations
          this.delete(row);
          return;
        }

        this.save();
      })
    },

    /**
     * update automations
     * 
     * @return void
     */
    onUpdate () {
      this.save();
    },

    /**
     * get email automations for this account
     * 
     * @return void
     */
    getAutomations () {
      return axios
        .get(`/admin/account/${this.accountId}/automated-emails`)
        .then(result => result.data)
    },


    /**
     * delete an automation
     * 
     * @return void
     */
    delete (row) {

      const {type, targetLanguage: language} = row;

      axios.delete(`/admin/account/${this.accountId}/automated-emails`, {data: {
        type,
        language,
      }}).then(result => {
        
      })
    },


    /**
     * save the automations
     * 
     * @return void
     */
    save () {

      let automations = this.rows;

      //make sure the automations contain emails
      //remove those that don't
      automations = automations.filter(automation => automation.emails.length > 0);

      //if there's no automations stop
      if (!automations.length) return;

      axios.post(`/admin/account/${this.accountId}/automated-emails`, {
        automations
      }).then(result => {
        let {updated_automations} = result.data;

        //

        console.log('result.data', result.data);

        console.log('the updated', updated_automations);

        updated_automations.forEach(automation => {
          let automationupdated = this.updateAutomation(automation);

          console.log('automationupdated', automationupdated);
        })
      })
    },

    /**
     * 
     * Update automation with new id or data
     * 
     * @param Object data
     * 
     * @return Object updatedAutomation
     * 
     */
    updateAutomation (data) {
      let automationIndex = this.rows.findIndex(automation => {
        return automation.type == data.type && automation.targetLanguage == data.targetLanguage;
      });

      if (automationIndex < 0) {
        return console.log('cannot find automation');
      }

      let updatedAutomation = Object.assign({}, this.rows[automationIndex], data);

      this.$set(this.rows, automationIndex, updatedAutomation);

      return this.rows[automationIndex];
    },

    /**
     * When the user adds a new email
     * 
     * @return void
     */
    onEmail (email, row) {
      //check that it's an email
      if (!isEmail(email)) return console.error('not an email', email);

      //add new email to this languages email array
      row.emails.push(email);

      this.save();
    },

    /**
     * Get an array of available types for a particular langauge.
     * Exclude types already selected for this language.
     * 
     * @param String targetLangauge - 'English (US)'
     * @param String|null selectedType - 'Advertising'
     * 
     * @return Array ['Advertising', 'Apps', ...]
     */
    availableTypes (targetLanguage, selectedType) {
      let selectedTypes = this.selectedTypes[targetLanguage];

      //exclude types previously selected for this language
      let availableTypes = this.types.filter(type => !selectedTypes.includes(type) || type == selectedType);

      return availableTypes;
    },


    /**
     * Delete a group of languages and emails
     * 
     * @param Number indx - index of current row to delete
     * @param Object row
     * 
     * @return void
     */
    deleteRow (indx, row) {
      this.rows.splice(indx, 1);

      this.delete(row);
    },

    /**
     * Add new row for Target language, type, and emails
     * 
     * @return Array ['Advertising', 'Apps', ...]
     */
    addRow() {
      let defaultTargetLanguage = null;

      //find the first target language that has a list of possible 
      //types to select from
      for (let i = 0; i < this.languages.length; i++)  {
        let targetLanguage = this.languages[i];

        //if no avaialble types for this language, then 
        //move to the next language available
        //otherwise select it
        if (this.availableTypes(targetLanguage).length) {
          defaultTargetLanguage = targetLanguage;
          break;
        }
      }

      //if none then don't add a new row
      if (!defaultTargetLanguage) {
        console.log('no target languages with mathcing pairs')
        return false;
      }

      this.rows.push({
        targetLanguage: defaultTargetLanguage,
        type: '',
        emails: [],
      });
    },
  },
};
</script>


<style scoped>
.toggle-automated {
  margin-bottom: 15px;
}

.add-more-langs-btn {
    padding: 10px 15px;
    border-radius: 5px;
    border: 1px solid #ccc;
    margin-top: 15px;
}

.delete-btn {
  margin-left: 10px;
  width: 100px;
  padding: 10px 5px;
  /* background-color: #fff; */
  border: 1px solid #ccc;
  border-radius: 5px;
}

.target-language-select{
  min-width: 185px;
  margin-right: 20px;
}

.target-language-emails .multiselect__tags {
  border: 1px solid #ccc;
}

.row {
  display: flex;
  justify-content: space-between;
  align-items:center;
  margin-bottom: 10px;
}
</style>
